import React from 'react';
import {
  Typography,
  TableRow,
  TableCell,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  labelCell: {
    width: '40%',
    borderBottom: 'none',
  },
  valueCell: {
    width: '60%',
    borderBottom: 'none',
  },
  boldText: {
    fontWeight: 'bold',
  },
}));

const StatusRow = ({ name, content, bold = false, rawContent = false }) => {
  const classes = useStyles();
  const displayContent = content && content !== null ? content : '';

  return (
    <TableRow>
      <TableCell className={classes.labelCell}>
        {name}
      </TableCell>
      <TableCell className={classes.valueCell}>
        {rawContent ? (
          displayContent
        ) : (
          <Typography component="div" variant="body2" color="textSecondary" className={bold ? classes.boldText : ''}>
            {displayContent}
          </Typography>
        )}
      </TableCell>
    </TableRow>
  );
};

export default StatusRow;
